export const tabIds = {
  profile: 'profile',
  security: 'security',
  preferences: 'preferences',
}
